import React, { useState, useEffect } from 'react';
import './Contact.css';
import { getContactSettings } from '../firebase/dataService';
import ContactFormModal from './ContactFormModal';

function Contact() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadSettings();
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const loadSettings = async () => {
    try {
      const data = await getContactSettings();
      setSettings(data);
    } catch (error) {
      console.error('Error loading contact settings:', error);
      // استخدام القيم الافتراضية في حالة الخطأ
      setSettings({
        visible: true,
        title: 'تواصل معنا',
        subtitle: 'نسعد بتواصلكم واستفساراتكم',
        email: 'admin@salman-alkhatep.com',
        twitter: {
          enabled: true,
          url: 'https://x.com/salman_alKhatep',
          handle: '@salman_alKhatep',
          description: 'تابعنا على تويتر للحصول على آخر التحديثات والفوائد اليومية'
        },
        youtube: {
          enabled: true,
          url: 'https://youtube.com/channel/UCJCc6TojI38et5ckeUikRWg?si=SV2ju6GjGLgrKHTB',
          handle: 'قناة سلمان الحران',
          description: 'اشترك في قناتنا على يوتيوب لمشاهدة الدروس والمحاضرات المرئية'
        },
        telegram: {
          enabled: true,
          url: 'https://t.me/salman_alkhatep',
          handle: '@salman_alkhatep',
          description: 'انضم إلى قناتنا على تلجرام للحصول على الفوائد والتصاميم الجديدة'
        },
        responseTime: {
          enabled: true,
          title: 'أوقات الرد',
          description: 'نسعى للرد على جميع الاستفسارات في أقرب وقت ممكن'
        },
        suggestions: {
          enabled: true,
          title: 'اقتراحاتكم',
          description: 'نرحب بجميع الاقتراحات والملاحظات'
        }
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="contact-page">
        <div className="loading-container">
          <div className="loader"></div>
          <p>جاري التحميل...</p>
        </div>
      </div>
    );
  }

  if (!settings || !settings.visible) {
    return (
      <div className="contact-page">
        <div className="contact-container">
          <div className="contact-header">
            <h1 className="contact-title">⚠️ الصفحة غير متاحة</h1>
            <div className="title-divider"></div>
            <p className="contact-subtitle">عذراً، صفحة التواصل غير متاحة حالياً</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-page">
      <div className="contact-container">
        <div className="contact-header">
          <h1 className="contact-title">{settings.title}</h1>
          <div className="title-divider"></div>
          <p className="contact-subtitle">{settings.subtitle}</p>
        </div>

        <div className="contact-content">
          <div className="contact-methods">
            {settings.twitter?.enabled !== false && (
            <a 
              href={settings.twitter.url} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="contact-card twitter"
            >
              <div className="card-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </div>
              <h3 className="card-title">تويتر</h3>
              <p className="card-handle">{settings.twitter.handle}</p>
              <p className="card-description">{settings.twitter.description}</p>
            </a>
            )}

            {settings.youtube?.enabled !== false && (
            <a 
              href={settings.youtube.url} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="contact-card youtube"
            >
              <div className="card-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </div>
              <h3 className="card-title">يوتيوب</h3>
              <p className="card-handle">{settings.youtube.handle}</p>
              <p className="card-description">{settings.youtube.description}</p>
            </a>
            )}

            {settings.telegram?.enabled !== false && (
            <a 
              href={settings.telegram.url} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="contact-card telegram"
            >
              <div className="card-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                </svg>
              </div>
              <h3 className="card-title">تلغرام</h3>
              <p className="card-handle">{settings.telegram.handle}</p>
              <p className="card-description">{settings.telegram.description}</p>
            </a>
            )}
          </div>

          <div className="info-section">
            {settings.responseTime?.enabled !== false && (
            <div className="info-card">
              <div className="info-icon">
                <svg viewBox="0 0 24 24" fill="currentColor" style={{width: '48px', height: '48px'}}>
                  <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                </svg>
              </div>
              <h3 className="info-title">{settings.responseTime?.title || 'أوقات الرد'}</h3>
              <p className="info-text">{settings.responseTime?.description || 'نسعى للرد على جميع الاستفسارات في أقرب وقت ممكن'}</p>
            </div>
            )}

            {settings.suggestions?.enabled !== false && (
            <div className="info-card clickable-card" onClick={openModal}>
              <div className="info-icon">
                <svg viewBox="0 0 24 24" fill="currentColor" style={{width: '48px', height: '48px'}}>
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                </svg>
              </div>
              <h3 className="info-title">{settings.suggestions?.title || 'اقتراحاتكم'}</h3>
              <p className="info-text">{settings.suggestions?.description || 'نرحب بجميع الاقتراحات والملاحظات لتطوير المحتوى'}</p>
              <button className="info-link" style={{marginTop: '10px', fontFamily: "'Cairo', sans-serif"}}>إرسال رسالة</button>
            </div>
            )}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <ContactFormModal onClose={closeModal} />
      )}
    </div>
  );
}

export default Contact;
